/**
 * @generated SignedSource<<9fe0c84232f2ef0ce5d54f88c06c5490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductCarousel_viewer$data = {
  readonly videoUploadToolsFeatureFlag: boolean | null;
  readonly " $fragmentType": "ProductCarousel_viewer";
};
export type ProductCarousel_viewer$key = {
  readonly " $data"?: ProductCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarousel_viewer",
  "selections": [
    {
      "alias": "videoUploadToolsFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cbb6e4973231426288b342479e6beabb";

export default node;
